import React from 'react';
import { useHistory } from 'react-router';

import EmptyStateCard from '@/views/components/misc/EmptyStateCard';
import EnterpriseDetailInfo from '@/types/enterprise-detail-info';
import { getConquestAppUrl } from '@/utils/planning';

enum EmptyStateType {
  NO_IMPORTED_ACCOUNTS = 'NO_IMPORTED_ACCOUNTS',
  NO_PLAN = 'NO_PLAN',
}

type Props = {
  hasAccounts: boolean;
  hasPlan: boolean;
  planId?: string;
  enterprise?: EnterpriseDetailInfo;
};

export const ContactPlanAccountsEmptyState: React.FC<Props> = ({ hasAccounts, planId, hasPlan, enterprise }: Props) => {
  const history = useHistory();
  const i18nEmptyStatePath = 'EmptyStateCard.ContactDetailsPlanAccounts';
  const conquestUrl = getConquestAppUrl(enterprise);

  const onImportAccounts = () => {
    history.push(`/planning/${planId}/import-accounts`);
  };

  const emptyStateDefinition = {
    [EmptyStateType.NO_IMPORTED_ACCOUNTS]: {
      titlePath: `${i18nEmptyStatePath}.NoImportedAccounts.Title`,
      messagePath: `${i18nEmptyStatePath}.NoImportedAccounts.Message`,
      primaryButton: { label: `${i18nEmptyStatePath}.NoImportedAccounts.PrimaryButtonText`, onClick: () => onImportAccounts() },
    },
    [EmptyStateType.NO_PLAN]: {
      titlePath: `${i18nEmptyStatePath}.NoPlan.Title`,
      messagePath: `${i18nEmptyStatePath}.NoPlan.Message`,
      links: conquestUrl ? [{ label: `${i18nEmptyStatePath}.NoPlan.LinkText`, isExternalLink: true, to: conquestUrl }] : undefined,
    },
  };

  const getEmptyStateType = (): EmptyStateType | undefined => {
    if (!hasPlan) {
      return EmptyStateType.NO_PLAN;
    }
    if (!hasAccounts) {
      return EmptyStateType.NO_IMPORTED_ACCOUNTS;
    }
  };

  const emptyStateType = getEmptyStateType();
  return <>{emptyStateType ? <EmptyStateCard {...emptyStateDefinition[emptyStateType]} /> : null}</>;
};
